import axios, { Method } from "axios";

export class ApiService {
  public static async baseAction(url: string, payload: any, method: Method) {
    try {
      const res = await axios({
        baseURL: process.env.VUE_APP_PROXY_API_ALIAS,
        method,
        withCredentials: true,
        timeout: 60000,
        timeoutErrorMessage: "ETIMEOUT",
        url,
        data: payload.data || {},
        params: {
          ...(payload.params || {}),
        },
      });
      return res.data;
    } catch ({ response: { data } }) {
      return data;
    }
  }
}
